<template lang="pug" >
transition(name="modal-fade")
  .confirm-modal-backdrop(role="dialog" v-if="data")
    .confirm-modal.column(@click.stop)
      .content.row.center(v-html="data.text")
      .actions.row.center.around
        button.red(@click="data.cancel();$root.confirm_modal = null;") {{ t.cancel }}
        button.green(@click="data.confirm();$root.confirm_modal = null;") {{ t.confirm }}
</template>
<script>
export default {
  props: ['data'],
}
</script>
<style>
.confirm-modal {
  position:fixed;
  left: calc(50vw - 200px);
  top: calc(50vh - 100px);
  width: 400px;
  background: white;
  border-radius: 8px;
  padding: 24px 24px 16px 24px;
}
.confirm-modal .content {
  flex: 1;
  margin-bottom: 12px;
}
.confirm-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right:0;
  bottom:0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 110;
  background: rgba(0,0,0,0.3);
}
</style>
